module.exports = __webpack_public_path__ + "img/slide4.209eba63.png";